<div class="week-days-header"
     [class.disabled]="disabled"
     [ngbPopover]="daysTpl"
     #daysPopover="ngbPopover"
     triggers="manual"
     container="body"
     placement="bottom-start bottom-end top-start top-end auto"
     autoClose="outside"
     popoverClass="working-days-popup">
  <div class="week-days-top" (click)="togglePopover(daysPopover)">
    <span class="week-days-name">{{ params.displayName }}</span>
    <span class="icon-as-date week-days-icon" aria-hidden="true"></span>
  </div>
  <span class="week-days-label" (click)="togglePopover(daysPopover)">{{ label }}</span>
</div>

<ng-template #daysTpl>
  <div class="working-days-popover">
    <div class="working-days-title">
      {{ 'learning.curve.dialog.working.days.title' | translate: { '0': weekNumber } }}
    </div>
    <div class="working-days-list">
      <div class="checkbox" *ngFor="let item of dayCheckboxes" (click)="onToggle(item)">
        <input type="checkbox"
               [checked]="item.checked"
               (click)="$event.preventDefault()"
               tabindex="-1">
        <label>{{ item.labelKey | translate }}</label>
      </div>
    </div>
    <breeze-button class="apply-all-btn"
                   [isSecondary]="true"
                   [showTooltip]="false"
                   buttonText="{{ 'learning.curve.dialog.apply.to.all.weeks' | translate }}"
                   (clicked)="onApplyToAll()"></breeze-button>
  </div>
</ng-template>
